import { EntityHeader } from "../../../shared-gen/Model/Utils/EntityHeader";
import { EntityType }   from "../../../shared-gen/Model/Utils/EntityType";

export class EntityHeaderFun {

	static createNew(): EntityHeader {
		return {
			Type: EntityType.Device,
			ID: "",
			Name: "",
			Hash: null as any,
		 	HashShort: "",
			ProviderID: "",
			LastChangeDate: null
		}
	}

}
